/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Check_ErrorInputs */

const en_cv_check_error = /** @type {(inputs: Cv_Check_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An error occurred. Please try again.`)
};

const de_cv_check_error = /** @type {(inputs: Cv_Check_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Fehler ist aufgetreten. Bitte versuche es erneut.`)
};

/**
* | output |
* | --- |
* | "An error occurred. Please try again." |
*
* @param {Cv_Check_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cv_check_error = /** @type {((inputs?: Cv_Check_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Check_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_check_error(inputs)
	return en_cv_check_error(inputs)
});